import { Stack } from '@mui/material';

import { PageHeader } from '@/components/navigation/PageHeader';
import { useRequiredParam } from '@/hooks/useRequiredParam';

import { ClientValuePerformanceDashboard } from './ClientValuePerformanceDashboard';

export function ClientDetailsPerformancePage() {
  const householdId = useRequiredParam('householdId');

  return (
    <Stack>
      <PageHeader heading="Value creation" />
      <Stack p={2} flex={1}>
        <ClientValuePerformanceDashboard householdId={householdId} />
      </Stack>
    </Stack>
  );
}
